import React from "react";
import "./style.css";
import { useNavigate } from "react-router-dom";

const MakeSimple = () => {
  const navigate = useNavigate();
  return (
    <div className={"MakeSimpleContainer"} id="apropos">
      <p className={"titleSimple"}>Pour faire Simple</p>
      <p className={"DescriptionSimple"}>
        Avoir un compte à <span>EasyLab.tn</span> vous aide à reprendre
        l’Artiste caché en vous et votre compte EasyLab vous facilite toute vos
        tâches orgnisationnelles Quotidienne en un click de façon tres
        simpifiée, Intuitive, dynamique, Multi-utilisateurs et EASY-To-USE.
      </p>
      <div style={{ textAlign: "center" }}>
        <button
          onClick={() => navigate("/register")}
          className={"Discover-Cover-button"}
          to={"/login"}
        >
          Innovez et restez compétitif
        </button>
      </div>
    </div>
  );
};

export default MakeSimple;
